import React from 'react';
import { Apple, Play, Facebook, Instagram, Youtube, Linkedin, Music } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white py-16">
      <div className="container mx-auto px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          {/* Main Footer Content */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
            {/* Brand & Download */}
            <div className="space-y-6">
              










              
              {/* App Download Buttons */}
              <div className="space-y-3">
                <p className="text-sm text-gray-400 font-semibold">Baixe o app:</p>
                <a
                  href="#"
                  className="flex items-center gap-3 bg-gray-800 hover:bg-gray-700 transition-colors px-4 py-3 rounded-lg group">

                  <Play className="w-6 h-6 text-[#0D7FA3] group-hover:scale-110 transition-transform" />
                  <div className="text-left">
                    <p className="text-xs text-gray-400">Disponível no</p>
                    <p className="font-semibold">Google Play</p>
                  </div>
                </a>
                
                <a
                  href="#"
                  className="flex items-center gap-3 bg-gray-800 hover:bg-gray-700 transition-colors px-4 py-3 rounded-lg group">

                  <Apple className="w-6 h-6 text-[#0D7FA3] group-hover:scale-110 transition-transform" />
                  <div className="text-left">
                    <p className="text-xs text-gray-400">Baixar na</p>
                    <p className="font-semibold">App Store</p>
                  </div>
                </a>
              </div>
            </div>

            {/* Partnerships */}
            <div className="space-y-6">
              <div>
                <h3 className="font-bold text-lg mb-4">Parcerias</h3>
                <div className="space-y-4">
                  {/* TOEFL Partnership */}
                  <div className="bg-gray-800 p-4 rounded-lg">
                    <div className="flex items-center gap-3 mb-2">
                      <div className="w-12 h-12 bg-blue-600 rounded-lg flex items-center justify-center">
                        <span className="text-white font-bold text-xs">MASTER<br />TEST</span>
                      </div>
                      <div className="flex-1">
                        <p className="text-xs text-gray-400">Distribuidora exclusiva do</p>
                        <p className="font-bold text-sm">TOEFL ITP® no Brasil</p>
                      </div>
                    </div>
                  </div>
                  
                  {/* Reclame Aqui Badge */}
                  <div className="bg-gray-800 p-4 rounded-lg flex items-center gap-3">
                    <div className="w-10 h-10 bg-white rounded-full flex items-center justify-center">
                      <span className="text-blue-600 text-2xl">✓</span>
                    </div>
                    <div>
                      <p className="text-xs text-gray-400">Verificada por</p>
                      <p className="font-bold">Reclame AQUI</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Security Seals */}
            <div>
              <h3 className="font-bold text-lg mb-4">Selos e certificados</h3>
              <div className="flex flex-wrap gap-3">
                <div className="bg-gray-800 px-4 py-3 rounded-lg hover:bg-gray-700 transition-colors">
                  <div className="flex items-center gap-2">
                    <div className="w-6 h-6 bg-green-500 rounded-full flex items-center justify-center">
                      <span className="text-white text-xs font-bold">✓</span>
                    </div>
                    <span className="font-semibold">Google</span>
                  </div>
                  <p className="text-xs text-gray-400 mt-1">Site Seguro</p>
                </div>
              </div>
            </div>

            {/* Payment Methods */}
            <div>
              <h3 className="font-bold text-lg mb-4">Formas de pagamento</h3>
              <div className="bg-gray-800 rounded-lg p-4">
                <img
                  src="https://static.lumi.new/ed/ed46cd96fe3cd27e739cc37a0824b129.webp"
                  alt="Formas de pagamento aceitas"
                  className="w-full h-auto object-contain" />

              </div>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="border-t border-gray-800 pt-8">
            {/* Social Media */}
            <div className="mb-8 text-center">
              <h3 className="font-bold text-lg mb-6">Siga-nos nas redes sociais</h3>
              <div className="flex justify-center gap-4">
                <a
                  href="https://www.facebook.com/englishwork.br"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-14 h-14 bg-gray-800 rounded-full flex items-center justify-center hover:bg-[#0D7FA3] transition-all duration-300 group">
                  <Facebook className="w-6 h-6 text-gray-300 group-hover:text-white group-hover:scale-110 transition-all" />
                </a>
                <a
                  href="https://www.instagram.com/ewpass/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-14 h-14 bg-gray-800 rounded-full flex items-center justify-center hover:bg-[#C64DAD] transition-all duration-300 group">
                  <Instagram className="w-6 h-6 text-gray-300 group-hover:text-white group-hover:scale-110 transition-all" />
                </a>
                <a
                  href="https://www.youtube.com/@englishwork"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-14 h-14 bg-gray-800 rounded-full flex items-center justify-center hover:bg-red-600 transition-all duration-300 group">
                  <Youtube className="w-6 h-6 text-gray-300 group-hover:text-white group-hover:scale-110 transition-all" />
                </a>
                <a
                  href="https://www.linkedin.com/in/english-work/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-14 h-14 bg-gray-800 rounded-full flex items-center justify-center hover:bg-blue-600 transition-all duration-300 group">
                  <Linkedin className="w-6 h-6 text-gray-300 group-hover:text-white group-hover:scale-110 transition-all" />
                </a>
                <a
                  href="https://www.tiktok.com/@englishwork_br"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-14 h-14 bg-gray-800 rounded-full flex items-center justify-center hover:bg-black transition-all duration-300 group">
                  <Music className="w-6 h-6 text-gray-300 group-hover:text-white group-hover:scale-110 transition-all" />
                </a>
              </div>
            </div>
            
            <div className="flex flex-col md:flex-row justify-between items-center gap-4">
              <p className="text-gray-400 text-sm text-center md:text-left">English Work Sociedade de Ensino Ltda © 2025 - Todos os direitos reservados | CNPJ: 48.620.557/0001-51

              </p>
              
              <div className="flex gap-6 text-sm text-gray-400">
                <a href="#" className="hover:text-white transition-colors">Política de Privacidade</a>
                <a href="#" className="hover:text-white transition-colors">Termos de Uso</a>
                
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>);

};

export default Footer;